import styles from "./YuJaCheckbox.module.css";
import {BsCheckLg} from "react-icons/bs";
import {useEffect, useState} from "react";
import { TEXTBOX } from "../../utils/constants";
import {generateUUID} from "../../utils/helpers";


export const YuJaCheckbox = ({checked=false, id="", disabled=false, label="", ariaLabel="", color, onClick, size=24, ...props}) => {
    const [randomId, ] = useState(() => generateUUID());
    const {style, ...inputProps} = props;
    const [inputVal, setInputVal] = useState(checked);

    const onClickEvent = (e) => {
        if (disabled) {
            return
        }



        const box = document.querySelector(`[data-yuja-checkbox-id='${randomId}']`);
        if (box) {
            box.click();
        }
    }

    const onChangeFunc = (e) => {
        setInputVal(e.target.value);
        if (onClick) {
            onClick(e);
        }
    }

    useEffect(() => {
        setInputVal(checked);
    }, [checked])

    return (
        <div className={styles.container} style={style} onClick={onClickEvent}>
            <div
                tabIndex={0}
                style={{width: size, height: size, border: color ? `1.5px solid ${color}` : ""}}
                className={`${styles.box} ${checked ? styles.checked : styles.unchecked} ${disabled ? styles.disabled : ""}`}
                id={id}
                aria-label={ariaLabel}
                role={TEXTBOX}
            >
                <input data-yuja-checkbox-id={randomId} name={props.name} type={"checkbox"} style={{display: "none"}}
                       checked={inputVal} {...inputProps} onChange={onChangeFunc} aria-label={label}/>
                {checked &&
                    <BsCheckLg size={size * 0.7} fill={"#FFFFFF"}/>
                }
            </div>
            {label &&
                <span className={`${styles.label} ${disabled ? styles.disabledLabel : ""}`}>{label}</span>
            }
        </div>
    )
}